import React, { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { fmtErr } from "../api";
import Seo from "../components/Seo";

export default function SetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Passwords do not match");
    setError(""); setBusy(true);
    try {
      await api.post("/auth/set-password", { token, password });
      setDone(true);
    } catch (err) { setError(fmtErr(err)); }
    setBusy(false);
  };

  const inputCls = "cr-input";

  return (
    <div className="max-w-sm mx-auto px-4 py-24" data-testid="set-password-page">
      <Seo title="Set password | CourierRadar" noindex />
      {done ? (
        <div className="text-center">
          <h1 className="text-2xl font-extrabold tracking-tight">Password set</h1>
          <p className="text-sm text-zinc-500 mt-3">You can now sign in. All previous sessions were revoked.</p>
          <button onClick={() => navigate("/auth")} data-testid="set-password-signin"
            className="mt-6 bg-black text-white px-6 py-3 rounded-lg text-sm font-medium">Sign in</button>
        </div>
      ) : (
        <>
          <h1 className="text-2xl font-extrabold tracking-tight">Set your password</h1>
          <p className="text-sm text-zinc-500 mt-2 mb-6">Choose a private password (min 8 characters).</p>
          {!token && <p className="text-sm text-red-600 mb-4">Missing setup link. Use the link from your email.</p>}
          <form onSubmit={submit} className="space-y-3">
            <input data-testid="new-password" type="password" required minLength={8} placeholder="New password"
              value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
            <input data-testid="confirm-password" type="password" required minLength={8} placeholder="Confirm password"
              value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} />
            {error && <p data-testid="set-password-error" className="text-xs text-red-600">{error}</p>}
            <button data-testid="set-password-submit" disabled={busy || !token}
              className="w-full bg-black text-white hover:bg-zinc-800 font-medium transition-colors px-5 py-3 rounded-lg text-sm disabled:opacity-40">
              {busy ? "Saving…" : "Set password"}
            </button>
          </form>
        </>
      )}
    </div>
  );
}
